import { attachActions } from './DamActions';
import axios from 'axios';

export class DamAssets {
    async assets() {
        const urlSearchParams = new URLSearchParams(window.location.search);

        const { data } = await axios.get(window.location.search, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }
        );

        if (data.draw == urlSearchParams.get('draw')) {
            document.querySelector('.dam-content-right').innerHTML = data.content;

            attachActions();
        }
    }
}
